import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { InitComponent } from './components/init/init.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PeersComponent } from './components/peers/peers.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { DidsComponent } from './components/dids/dids.component';
import { BinasComponent } from './components/binas/binas.component';
import { PermissionsComponent } from './components/permissions/permissions.component';
import { CallsComponent } from './components/calls/calls.component';
import { TtsComponent } from './components/tts/tts.component';



const routes: Routes = [
  { path: '', redirectTo: 'dash', pathMatch: 'full' },
  { path: 'init/:jwt', component: InitComponent },
  { path: 'dash', component: DashboardComponent },
  { path: 'calls', component: CallsComponent },
  { path: 'tts', component: TtsComponent },
  { path: 'peers', component: PeersComponent },
  { path: 'dids', component: DidsComponent },
  { path: 'binas', component: BinasComponent },
  { path: 'permissions', component: PermissionsComponent},
  { path: 'notfound', component: NotFoundComponent }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [ RouterModule ]
})


export class AppRoutingModule { }
